import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }
  

  getUsuarios(filter:any){
    return this.http.get(`${this.baserApiUrl}usuarios?${filter}`)
  }

  addUsuario(data:any){
    return this.http.post(`${this.baserApiUrl}usuarios`,data)
  }

  updateUsuario(data:any,options:any){
    return this.http.put(`${this.baserApiUrl}usuarios`,data,options)
  }

  loginUsuario(data:any){
    return this.http.post(`${this.baserApiUrl}usuarios/login/`,data)
  }
}
